import { Component, EventEmitter, Output } from "@angular/core";

@Component({
    selector: 'terms',
    templateUrl: '../../view/join/terms.html'
})
export class TermsComponent {
    public isAllTermsChecked: boolean = false;
    public isTermsOfServiceChecked: boolean = false;
    public isPrivacyPolicyChecked: boolean = false; 

    @Output() public cancelEvent: EventEmitter<any> = new EventEmitter<any>();
    @Output() public nextEvent: EventEmitter<any> = new EventEmitter<any>();

    public toggleAllCheckedState(): void {
        this.isAllTermsChecked = !this.isAllTermsChecked;

        this.isTermsOfServiceChecked = this.isAllTermsChecked;
        this.isPrivacyPolicyChecked = this.isAllTermsChecked;
    }

    public toggleCheckedState(target: boolean): void {
        target = !target;

        this.isAllTermsChecked = this.isTermsOfServiceChecked && this.isPrivacyPolicyChecked;
    }

    public cancel(): void {
        this.cancelEvent.emit();
    }

    public next(): void {
        if (this.isAllTermsChecked) {
            this.nextEvent.emit();
        }
    }
}